import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import PageHeader from '../components/ui/PageHeader';
import { FadeIn } from '../components/ui/AnimatedSection';
import { useTranslation } from 'react-i18next';

export default function Legal() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col font-sans text-black-deep bg-cream-100">
      <Navbar />
      
      <main className="flex-grow">
        <PageHeader 
          title={t('legalPage.headerTitle')} 
          subtitle={t('legalPage.headerSubtitle')}
          imagePath="/assets/luxury_interior.webp" 
        />

        <section className="py-24 bg-white relative">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <FadeIn>
              <div className="prose prose-lg prose-gold max-w-none text-gray-700 font-light">
                <p className="text-sm text-gray-400 mb-12 uppercase tracking-widest font-bold">
                  {t('legalPage.lastUpdate', { date: new Date().toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' }) })}
                </p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('legalPage.art1Title')}</h2>
                <p dangerouslySetInnerHTML={{ __html: t('legalPage.art1P1') }}></p>
                <ul className="list-none pl-0 space-y-2 mt-4">
                  <li dangerouslySetInnerHTML={{ __html: t('legalPage.art1L1') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('legalPage.art1L2') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('legalPage.art1L3') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('legalPage.art1L4') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('legalPage.art1L5') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('legalPage.art1L6') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('legalPage.art1L7') }}></li>
                </ul>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('legalPage.art2Title')}</h2>
                <p>{t('legalPage.art2P1')}</p>
                <ul className="list-none pl-0 space-y-2 mt-4">
                  <li dangerouslySetInnerHTML={{ __html: t('legalPage.art2L1') }}></li>
                </ul>
                <p className="mt-4" dangerouslySetInnerHTML={{ __html: t('legalPage.art2P2') }}></p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('legalPage.art3Title')}</h2>
                <p dangerouslySetInnerHTML={{ __html: t('legalPage.art3P1') }}></p>
                <p className="mt-6" dangerouslySetInnerHTML={{ __html: t('legalPage.art3P2') }}></p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('legalPage.art4Title')}</h2>
                <p>{t('legalPage.art4P1')}</p>
                <p>{t('legalPage.art4P2')}</p>
                <p>{t('legalPage.art4P3')}</p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('legalPage.art5Title')}</h2>
                <p>{t('legalPage.art5P1')}</p>
                <h3 className="text-xl font-serif text-black-deep mt-8 mb-4">{t('legalPage.art5_1Title')}</h3>
                <p>{t('legalPage.art5_1P1')}</p>
                <h3 className="text-xl font-serif text-black-deep mt-8 mb-4">{t('legalPage.art5_2Title')}</h3>
                <p>{t('legalPage.art5_2P1')}</p>
                <h3 className="text-xl font-serif text-black-deep mt-8 mb-4">{t('legalPage.art5_3Title')}</h3>
                <p dangerouslySetInnerHTML={{ __html: t('legalPage.art5_3P1') }}></p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('legalPage.art6Title')}</h2>
                <p>{t('legalPage.art6P1')}</p>
                <p dangerouslySetInnerHTML={{ __html: t('legalPage.art6P2') }}></p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('legalPage.art7Title')}</h2>
                <p>{t('legalPage.art7P1')}</p>
                <p>{t('legalPage.art7P2')}</p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('legalPage.art8Title')}</h2>
                <p>{t('legalPage.art8P1')}</p>

              </div>
            </FadeIn>
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
}
